// keys usadas en las traducciones... podemos agregar separacion logica en el armado
const Menu = {
    Creditos: 'Créditos',
    ComoJugar: 'Cómo jugar',
};
const Nivel1 = {
    Tiempo: 'Tiempo restante:',
    }  
const GameOver = {
   GoBack: 'Volver al menú principal',
   JuegoTerminado: 'Juego terminado',
   Reiniciar: 'Reiniciar',
}
const Win = {
    GoBack: 'Volver al menú principal',
    TiempoRestante: '5 mejores tiempos restantes:',
}

export default {
    Menu,
    GameOver,
    Nivel1,
    Win,
};